import * as yup from 'yup'

export const freeSignupSchema = yup.object().shape({
  'bot-field': yup.string().max(0),
  admin_email: yup
    .string()
    .required()
    .trim()
    .email('Please provide a valid email')
    .label('Email'),
  first_name: yup.string().required().trim().label('First name'),
  last_name: yup.string().required().trim().label('Last name'),
})
